import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest,} from '@angular/common/http';
import {Observable} from 'rxjs';
import {LoaderService} from '../shared/services/loader.service';
import {finalize} from 'rxjs/operators';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private noLoaders = 0;

  private exceptionURLs = [
    'Product/GetAllProductsByFeatureNew?showLoader=true',
    'Banner/GetBannerById','paginated=true'
  ];

  constructor(private loaderService: LoaderService) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let showLoaderTrigger = false
    if(request.url.includes('showLoader=true')) {
      showLoaderTrigger = true;
      this.noLoaders++;
      this.loaderService.show();
    }else {
      const hasURLMatch = this.exceptionURLs.some(substring => request.url.includes(substring));

      if (hasURLMatch) {
        if(!showLoaderTrigger){
          this.noLoaders++;
          this.loaderService.show();
        }
      } else {
        this.noLoaders++;
        this.loaderService.show();

      }
    }

    return next.handle(request).pipe(
      finalize(() => {
        this.noLoaders--;
        if (this.noLoaders <= 0) {
          this.noLoaders = 0;
          this.loaderService.hide()
        }
      }),
    );
  }
}
